import { QuestionMarkedVoice } from '@/components/features/quiz/question/question-marked/question-voice';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { VoiceRecorder } from '@/components/ui/voice-recorder';
import { useQuestionVoice } from '@/hooks/questions';

import type { QuestionVoiceProps } from '.';

export function QuestionVoice(questionVoiceProps: QuestionVoiceProps) {
  const { question, showMarked } = questionVoiceProps;

  const { marked, audioBlob, exportedUserAnswer, handleValueChange } = useQuestionVoice(questionVoiceProps);
  return (
    <QuestionBase content={question.content} type={question.type}>
      <VoiceRecorder onRecordingStop={handleValueChange} value={audioBlob} disabled={showMarked} />
      <QuestionMarkedVoice marked={marked} showMarked={showMarked} question={question} answer={exportedUserAnswer} showQuestion={false} />
    </QuestionBase>
  );
}
